/**
 * Registro de codecs de URL (link compartilhável) — CONTRATO COMPARTILHADO.
 *
 * Cada módulo com estado relevante registra um codec com uma chave curta e
 * única. O módulo app-core monta a URL (query string) a partir de todos os
 * codecs e, na inicialização, entrega a cada um o valor lido.
 *
 * Chaves reservadas: app-core usa `c` (centro), `z` (zoom), `g` (camadas GOES),
 * `t` (tempo/período), `q` (qualidade), `v` (velocidade); focos usam `f` e
 * `a` (áreas do filtro dos últimos focos); vetores usam `m`; estações usam
 * `s`; radiossonda usa `r`; embarcações usam `n`; rios usam `h`; radar usa `e`;
 * fumaça usa `u`; estações meteorológicas usam `w`; qualidade do ar usa `p` (de partículas);
 * rastreio e previsão de nuvens usam `k`; o rastreio da chuva usa `i`; a busca usa `b`; o "Próximos dias"
 * (previsão de modelo) usa `y` (variável) e `d` (instante previsto).
 */
export interface UrlCodec {
  /** Chave curta e única do parâmetro na URL. */
  key: string;
  /** Estado atual → valor compacto para a URL, ou null para omitir o parâmetro. */
  encode: () => string | null;
  /**
   * Valor para as PREFERÊNCIAS SALVAS no navegador (urlSync.ts), quando difere
   * do link: sem o que é momentâneo (ex.: o instante do quadro em `t`). Omitido
   * = o mesmo de `encode`.
   */
  persist?: () => string | null;
  /** Aplica o valor lido da URL (uma vez, na inicialização). Deve tolerar lixo. */
  decode: (value: string) => void;
  /** Assina mudanças de estado que devem atualizar a URL. Retorna o cancelamento. */
  subscribe: (onChange: () => void) => () => void;
}

const codecs = new Map<string, UrlCodec>();

export function registerUrlCodec(codec: UrlCodec): void {
  codecs.set(codec.key, codec);
}

export function getUrlCodecs(): UrlCodec[] {
  return [...codecs.values()];
}
